<template>
<!-- 头部导航公共组件 -->
    <div class="navbar-header">
        <!-- 内容区域 -->
        <div class="container">
            <div class="fixedwidth">
                <!-- 时间和登录 -->
                <div class="time_login">
                    <!-- 时间显示 -->
                    <div class="timebox">
                        <div class="iconbox">
                            <span class="iconfont icon-rili"></span>
                        </div>
                        <div class="date_value">
                            {{ date_value }}
                        </div>
                        <div class="weekday">
                            {{ weekDay }}
                        </div>
                    </div>
                    <!-- 登录按钮 -->
                    <!-- <div class="btnbox" >
                        <button v-if="!token" @click="login">点击登录 <span class="el-icon-right"></span> </button>
                        <button v-else @click="goUserInfo">{{ userInfo.userName }} <span class="el-icon-right"></span></button>
                    </div> -->
                </div>

                <!-- logo 和 搜索框 -->
                <div class="logo_search">
                    <!-- logo -->
                    <div class="logo" v-if="logoImg">
                        <img :src="$imgUrl + logoImg" alt="" v-if="logoImg.indexOf('http') == -1">
                        <img :src="logoImg" alt="" v-else>
                    </div>
                    <div class="logo" v-else>
                        <img src="../../assets/static/index/index_logo.png" alt="">
                    </div>
                    <!-- search -->
                    <div class="search_box">
                        <input type="text" class="search_input" v-model="keyword" placeholder="请输入关键字">
                        <button class="search_icon" @click="search"><span class="el-icon-search"></span></button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 导航栏 -->
        <navbar-list></navbar-list>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import NavbarList from "./NavbarList"
import MenuList from "./MenuList"
import SwiperNews from "./SwiperNews"
    export default {
        data() {
            return {
                date_value: "", // 日期
                weekDay: "", // 星期几
                keyword: "", // 搜索关键字
                userInfo: {},
                logoImg:""
            }
        },
        mounted () {
            this.getTime()
            if ( this.token ) {
                this.getUserInfo()
            }
            this.getLogo()
        },
        computed: {
            ...mapGetters(['token'])
        },
        components: {
            NavbarList,
            MenuList,
            SwiperNews,
        },
        methods: {
            // 计算时间
            getTime () {
                let times = new Date()
                let YYYY = times.getFullYear()
                let MM = times.getMonth() + 1
                let DD = times.getDate()
                let dd = times.getDay()
                this.date_value = `${YYYY}-${MM}-${DD}`
                let str = ""
                switch (dd) {
                    case 0:
                        str = "星期日"
                        break;
                    case 1:
                        str = "星期一"
                        break;
                    case 2:
                        str = "星期二"
                        break;
                    case 3:
                        str = "星期三"
                        break;
                    case 4:
                        str = "星期四"
                        break;
                    case 5:
                        str = "星期五"
                        break;
                    case 6:
                        str = "星期六"
                        break;
                    default:
                        break;
                }
                this.weekDay = str
                
            },
            // 用户登录
            login () {
                this.$router.push("/login")
            },

            // 获取用户信息
            async  getUserInfo () {
                let { token } = this 
                let res = await this.$axios.post("/lencon/pc/person/simple_info", { token  })
                if ( res.data.code == 1 ) {
                    this.userInfo = res.data.obj
                } else {
                    localStorage.removeItem('token')
                    this.$store.commit("getToken", "")
                }
            },

            // 去个人中心
            goUserInfo () {
                this.$router.push("/user")
            },

            // 点击搜索
            search() {
                if( this.keyword ) {
                    this.$router.push({
                        path: "/moreNewsList",
                        query: {
                            isSearch: 1,
                            keyword: this.keyword
                        }
                    })
                } else {
                    return this.$message.error("请输入关键字")
                }
            },

            // 获取logo
            async getLogo(){
                let res = await this.$axios.post("/lencon/pc/index/theme", { id: 8  })
                if(res.data.code == 1){
                    this.logoImg = res.data.res.img
                }
            }

         }
    }
</script>

<style lang="scss" scoped>
.navbar-header {
    min-width: 1200px;
    margin: 0 auto;
    .container {
        width: 100%;
        height: 213px;
        background: url("../../assets/static/new/gonghui_bg1.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        .fixedwidth{
            width: 1200px;
            height: inherit;
            margin: 0 auto;
        }
        .time_login {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 10px 0;
            color: #ffffff;
            border-bottom: 1px solid rgba(255,255,255,0.24);
            .timebox {
                display: flex;
                align-items: center;
                font-size: 14px;
                div {
                    margin: 0 10px;
                }
            }
            .btnbox {
                margin-left: 20px;
                cursor: pointer;
                button {
                    cursor: pointer;
                    width: 125px;
                    font-size: 16px;
                    height: 36px;
                    background: rgba(203, 19, 19, 0.55);
                    border-radius: 10px;
                    outline: none;
                    border: none;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }

        .logo_search {
            width: 1200px;
            // width: ContainerBox;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 30px;
            .search_box {
                width: 320px;
                height: 45px;
                display: flex;
                align-items: center;
                
                .search_input {
                    width: 260px;
                    height: 45px;
                    border-radius: 10px 0 0 10px;
                    margin: 0;
                    outline: none;
                    box-sizing: border-box;
                    background-color: rgba(255,255,255,0.27);
                    border: none;
                    padding: 0 15px;
                    font-size: 16px;
                    color: #ffffff;
                    
                    &::placeholder {
                        color: #ffffff;
                    }
                }
                .search_icon {
                    cursor: pointer;
                    width: 60px;
                    height: 45px;
                    background: white;
                    box-sizing: border-box;
                    line-height: 45px;
                    text-align: center;
                    border-radius: 0 10px 10px 0;
                    font-size: 20px;
                    color: #2967BC;
                    outline: none;
                    border: 1px solid #ffffff;
                }
            }
        }
    }
}

</style>